import React from "react";
import NewsArticleLayout from "../../../components/updated-article/NewsArticleLayout.component";

const isNew = true;
const href = "/ratesheet/20250509-Rate-Sheet.pdf";
const date = "09.05.2025";

const Article = () => (
  <NewsArticleLayout href={href} date={date} isNew={isNew}>
    <h1 className="page-title">Changes to our mortgage products</h1>
    <p>With effect from Friday 9 May 2025 we will be making the following changes to our range:</p>
    <p>
      <strong>Summary of changes</strong>
    </p>
    <p>
      <strong>Following the Monetary Policy Committee announcement on Thursday 8 May 2025, the Bank of England Base Rate has reduced from 4.50% to 4.25%.</strong>
    </p>
    <p>With effect from Friday 9 May 2025 the changes are as follows:</p>
    <ul>
      <li>All tracker rates will include the reduced Bank of England Base Rate.</li>
      <li>There are no changes to our Residential Standard Variable Rate or Buy to Let Standard Variable Rate.</li>
    </ul>
    <p>There are no other changes to our interest rates.</p>
    <p>An updated mortgage rate sheet will be published on Friday 9 May 2025 to reflect these changes</p>
  </NewsArticleLayout>
);

export default Article;
